import { createIcons, icons } from 'lucide';

/**
 * After inserting any HTML that contains `data-lucide="icon-name"` elements,
 * call refreshIcons() to swap them for real SVGs.
 */
export function refreshIcons() {
  createIcons({ icons });
}

/** Convenience: render a single lucide icon by name with optional class. */
export function icon(name: string, cls = 'w-4 h-4'): string {
  return `<i data-lucide="${name}" class="${cls}"></i>`;
}
